// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z2GKka8Q4yS_G7FXiOQI {
  display: grid;
  gap: 1rem;
  width: min(36rem, 80vw);
  max-height: 70vh;
  overflow-y: auto;
  text-align: left;
}

.GGNKqf7Wkzi6uKOey9GT {
  margin: 0;
}

.qT5vPaA8SMGubnb18gT7 {
  display: grid;
  gap: 0.6rem;
}

.jVwfcKFJRnY8GvFtI76y {
  display: grid;
  gap: 0.4rem;
  padding: 0.6rem 0.8rem;
  border-radius: 0.6rem;
  background-color: var(--cl-main-light-2-transparent);
}

.QtVkAPSMGm2mRidd9gCL {
  font-weight: 600;
  color: var(--cl-main-dark);
}

.xjksZIdQmyVxCUEl0IeO {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/merchant/panel/scripts/shared/IntProvider/IntProviderEditor.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".editor {\n  display: grid;\n  gap: 1rem;\n  width: min(36rem, 80vw);\n  max-height: 70vh;\n  overflow-y: auto;\n  text-align: left;\n}\n\n.title {\n  margin: 0;\n}\n\n.section {\n  display: grid;\n  gap: 0.6rem;\n}\n\n.preview {\n  display: grid;\n  gap: 0.4rem;\n  padding: 0.6rem 0.8rem;\n  border-radius: 0.6rem;\n  background-color: var(--cl-main-light-2-transparent);\n}\n\n.summary {\n  font-weight: 600;\n  color: var(--cl-main-dark);\n}\n\n.calculator {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var editor = `z2GKka8Q4yS_G7FXiOQI`;
export var title = `GGNKqf7Wkzi6uKOey9GT`;
export var section = `qT5vPaA8SMGubnb18gT7`;
export var preview = `jVwfcKFJRnY8GvFtI76y`;
export var summary = `QtVkAPSMGm2mRidd9gCL`;
export var calculator = `xjksZIdQmyVxCUEl0IeO`;
export default ___CSS_LOADER_EXPORT___;
